const APP_ENVIRONMENT = {
  NAVER_APP: 0,
  PAY_APP: 2
};
const OS_ENVIRONMENT = {
  ANDROID: 0,
  IOS: 1
};
const ENVIRONMENT = {
  NAVER_APP_ANDROID: 'NAVER_APP_ANDROID',
  NAVER_APP_IOS: 'NAVER_APP_IOS',
  PAY_APP_ANDROID: 'PAY_APP_ANDROID',
  PAY_APP_IOS: 'PAY_APP_IOS'
};
const APP_OS_ENV = {
  [APP_ENVIRONMENT.NAVER_APP + OS_ENVIRONMENT.ANDROID]: ENVIRONMENT.NAVER_APP_ANDROID,
  [APP_ENVIRONMENT.NAVER_APP + OS_ENVIRONMENT.IOS]: ENVIRONMENT.NAVER_APP_IOS,
  [APP_ENVIRONMENT.PAY_APP + OS_ENVIRONMENT.ANDROID]: ENVIRONMENT.PAY_APP_ANDROID,
  [APP_ENVIRONMENT.PAY_APP + OS_ENVIRONMENT.IOS]: ENVIRONMENT.PAY_APP_IOS
};
/** shorten url 재시도 timeout */
const TIMEOUT = 30 * 60 * 1000;
const DEFAULT_SERVICE_MENU_OPTION = {
  menuName: 'myasset',
  url: ''
};

export { APP_ENVIRONMENT, APP_OS_ENV, DEFAULT_SERVICE_MENU_OPTION, ENVIRONMENT, OS_ENVIRONMENT, TIMEOUT };
